'use client';

import { c as _c } from "react/compiler-runtime";
import { Field, FieldError, FieldLabel, Switch } from '@repo/ui/components';
import { cn } from '@repo/ui/lib/utils';
import { ComponentProps, ReactNode, useId } from 'react';
import { useFieldContext } from '../lib/form-context.ts';
export const FormSwitch = t0 => {
  const $ = _c(30);
  let label;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      disabled: t1,
      isPending: t2,
      label,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = label;
    $[2] = props;
    $[3] = t1;
    $[4] = t2;
  } else {
    label = $[1];
    props = $[2];
    t1 = $[3];
    t2 = $[4];
  }
  const disabled = t1 === undefined ? false : t1;
  const isPending = t2 === undefined ? false : t2;
  const field = useFieldContext();
  let t3;
  if ($[5] !== field.state.meta.errors) {
    t3 = field.state.meta.errors ?? [];
    $[5] = field.state.meta.errors;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  const errors = t3;
  const id = useId();
  let t4;
  if ($[7] !== id || $[8] !== label) {
    t4 = <FieldLabel className="text-base" htmlFor={id} data-sentry-element="FieldLabel" data-sentry-source-file="form-switch.tsx">{label}</FieldLabel>;
    $[7] = id;
    $[8] = label;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const t5 = isPending || disabled;
  let t6;
  if ($[10] !== field) {
    t6 = checked => field.handleChange(checked === true);
    $[10] = field;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== field.state.value || $[13] !== id || $[14] !== props || $[15] !== t5 || $[16] !== t6) {
    t7 = <Switch checked={field.state.value} disabled={t5} id={id} onCheckedChange={t6} {...props} data-sentry-element="Switch" data-sentry-source-file="form-switch.tsx" />;
    $[12] = field.state.value;
    $[13] = id;
    $[14] = props;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== field.state.value || $[19] !== isPending) {
    t8 = field.state.value && <span className={cn("text-sm", isPending && "text-muted-foreground")}>Required</span>;
    $[18] = field.state.value;
    $[19] = isPending;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = <div className="flex h-5 items-center gap-2">{t7}{t8}</div>;
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  let t10;
  if ($[24] !== errors) {
    t10 = <FieldError className="text-sm" errors={errors} data-sentry-element="FieldError" data-sentry-source-file="form-switch.tsx" />;
    $[24] = errors;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== t10 || $[27] !== t4 || $[28] !== t9) {
    t11 = <Field className="gap-2" data-sentry-element="Field" data-sentry-component="FormSwitch" data-sentry-source-file="form-switch.tsx">{t4}{t9}{t10}</Field>;
    $[26] = t10;
    $[27] = t4;
    $[28] = t9;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};